import { AidFrontendFeatureGate } from '../providers/FeatureGates';
import { ThunkAction } from '../types';
import { extractErrorTypeFromResponse } from '../utilities/extract-error-from-response';
import submitFormHack, { submitFormHackReplacement } from '../utilities/submit-form';
import { checkFeatureGate } from '../utilities/feature-flags/feature-gate';

export const changeEmailConfirmation =
  (email: string, password: string): ThunkAction =>
  async (dispatch, getState) => {
    // Fork to use either the old submitFormHack or new submitFormHackReplacement function, well as the old or new endpoint
    // old endpoint: /verify-email/change-email (submitFormHack - form submission with input div manipulation)
    // new endpoint: /rest/verify-email/change-email (submitFormHackReplacement - REST POST request with JSON payload)
    if (!checkFeatureGate(AidFrontendFeatureGate.ENABLE_JSON_ENDPOINT_FOR_VERIFY_EMAIL)) {
      submitFormHack({
        method: 'POST',
        payload: { email, password },
        skipSanitizationKeys: ['password'],
      });

      return;
    }

    try {
      const csrfToken = getState().csrfToken;

      const res = await submitFormHackReplacement({
        method: 'POST',
        action: '/rest/verify-email/change-email',
        payload: { email, password },
        csrfToken,
      });

      const response = await res.json();

      if (response.redirectTo) {
        window.location.assign(response.redirectTo);
        return;
      }

      const errorType = extractErrorTypeFromResponse(response);

      if (errorType) {
        dispatch({
          type: 'SERVER_ERROR_UPDATE',
          error: { type: errorType },
        });
      }
    } catch (error) {
      const errorType = extractErrorTypeFromResponse(error);
      if (errorType) {
        dispatch({
          type: 'SERVER_ERROR_UPDATE',
          error: { type: errorType },
        });
      }
    }
  };
